import * as XLSX from 'xlsx-js-style';

const textStyle = (fillColor = "FFFFFF", horizontal = "center") => ({
  alignment: { horizontal },
  font: { name: "Roboto", sz: 12, color: { rgb: "6b6b6b" } },
  fill: { fgColor: { rgb: fillColor } }
});

const parseNumberCellValue = (value) => {
  if (typeof value === 'number') return value;
  if (!value) return 0;

  const valueString = String(value)
    .replace(/R\$\s?/g, '')
    .replace(/%/g, '')
    .replace(/M.*/g, '')
    .replace(/\s/g, '')
    .replace(/[^\d.,-]/g, '');

  if (!valueString) return 0;

  const normalized = valueString.includes(',')
    ? valueString.replace(/\./g, '').replace(/,/g, '.')
    : /^-?\d{1,3}(\.\d{3})+$/.test(valueString)
      ? valueString.replace(/\./g, '')
      : valueString;

  const numericValue = Number(normalized);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

const typedCell = (value, style, type = "text") => {
  if (type === "text") return { v: value, t: "s", s: style };

  const formats = {
    currency: '"R$" #,##0.00',
    decimal: '#,##0.00',
    percent: '0.00"%"'
  };

  return {
    v: parseNumberCellValue(value),
    t: "n",
    z: formats[type] || formats.decimal,
    s: style
  };
};

const economyColumnTypes = [
  "text",
  "currency",
  "currency",
  "decimal",
  "decimal",
  "currency",
  "percent",
  "percent"
];

export const generateXlsx = async (dataUnit) => {
  let wb = XLSX.utils.book_new();

  dataUnit.map((unit, index) => {
    let dataLines = []

    unit.monthSelect.map((line) => {
      let month = []
      for (let key in line) {
        const columnIndex = month.length
        const formatValue = columnIndex % 2 == 0 ? textStyle("FFFFFF", "left") : textStyle("F7F7F7", "left")
        month.push(typedCell(line[key], formatValue, economyColumnTypes[columnIndex]))
      }

      dataLines.push(month)

    })

    let whiteLine = [
      { v: " ", t: "s", s: { fill: { fgColor: { rgb: "FFFFFF" } } } },
    ];
    let headersUnitsData = [
      { v: unit.name, t: "s", s: { alignment: { horizontal: "center", vertical: "center", wrapText: true }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0086D7" } } } },
      { v: "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Tipo de Consumo", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Matricula", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Endereço", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
    ];
    let unitsData = [
      { v: " ", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: " ", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: " ", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: unit.tipoConsumo, t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: unit.matricula, t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: unit.address.uf + ", " + unit.address.bairro + ", " + unit.address.logradouro, t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: " ", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: " ", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
    ];
    let headersGeneralData = [
      { v: "Período", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Referencia", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "Valor", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Água (M³)", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "Esgoto (M³)", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Economia", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Meta", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
    ];
    let generalData = [
      { v: "Período", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "6b6b6b" } }, fill: { fgColor: { rgb: "FFFFFF" } } } },
      typedCell(unit.reference, textStyle("F7F7F7"), "currency"),
      typedCell(unit.account_value, textStyle("FFFFFF"), "currency"),
      typedCell(unit.water_liters, textStyle("F7F7F7"), "decimal"),
      typedCell(unit.sewer_liters, textStyle("FFFFFF"), "decimal"),
      typedCell(unit.economy_monetary, textStyle("F7F7F7"), "currency"),
      typedCell(unit.economy_percentage, textStyle("FFFFFF"), "percent"),
      typedCell(unit.goal, textStyle("F7F7F7"), "percent"),
    ];
    let headersDetails = [
      { v: "Data", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Referencia", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "Valor", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Água (M³)", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "Esgoto (M³)", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Economia", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Meta", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
    ];
    const datailName = [
      { v: "Detalhados", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 14, bold: true, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "095183" } } } },
    ];
    const generalDataName = [
      { v: "DADOS GERAIS", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 16, bold: true, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "095183" } } } },
    ];

    let ws = XLSX.utils.aoa_to_sheet([
      headersUnitsData,
      unitsData,
      whiteLine,
      generalDataName,
      headersGeneralData,
      generalData,
      whiteLine,
      datailName,
      headersDetails,
      ...dataLines
    ]);
    var wscols = [
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ];
    ws['!cols'] = wscols;

    XLSX.utils.book_append_sheet(wb, ws, index + "-" + unit.name.substr(0, 25));
    for (let key in wb.Sheets) {
      wb.Sheets[key]["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 1, c: 2 } },
        { s: { r: 0, c: 5 }, e: { r: 0, c: 7 } },
        { s: { r: 1, c: 5 }, e: { r: 1, c: 7 } },
        { s: { r: 2, c: 0 }, e: { r: 2, c: 7 } },
        { s: { r: 3, c: 0 }, e: { r: 3, c: 7 } },
        { s: { r: 4, c: 5 }, e: { r: 4, c: 6 } },
        { s: { r: 6, c: 0 }, e: { r: 6, c: 7 } },
        { s: { r: 7, c: 0 }, e: { r: 7, c: 7 } },
        { s: { r: 8, c: 5 }, e: { r: 8, c: 6 } },
      ]
    }
  })
  XLSX.writeFile(wb, `Relatorio-Economia.xlsx`);

}
export const generateResumeXlsx = async (dataClient) => {
  let wb = XLSX.utils.book_new();
  const infosClient = dataClient[0] || {}
  const clientAddress = infosClient.address || {}
  dataClient.map((client) => {
    let lengthNamesUnits = []
    let dataLines = []
    client.resultSumHistoric.map((unitResume, index) => {
      lengthNamesUnits.push(unitResume.name.length)
      dataLines.push([
        { v: unitResume.name, t: "s", s: { alignment: { horizontal: "left" }, font: { name: "Roboto", sz: 12, color: { rgb: "6b6b6b" } }, fill: { fgColor: { rgb: "FFFFFF" } } } },
        typedCell(unitResume.reference, textStyle("F7F7F7"), "currency"),
        typedCell(unitResume.account_value, textStyle("FFFFFF"), "currency"),
        typedCell(unitResume.water_liters, textStyle("F7F7F7"), "decimal"),
        typedCell(unitResume.sewer_liters, textStyle("FFFFFF"), "decimal"),
        typedCell(unitResume.economy_monetary, textStyle("F7F7F7"), "currency"),
        typedCell(unitResume.economy_percentage, textStyle("F7F7F7"), "percent"),
        typedCell(unitResume.goal, textStyle("FFFFFF"), "percent")
      ])
    })
    var maxLengthNameUnit = lengthNamesUnits.reduce(function(a, b) {
      return Math.max(a, b);
    }, -Infinity);

    let whiteLine = [
      { v: " ", t: "s", s: { fill: { fgColor: { rgb: "FFFFFF" } } } },
    ];
    let headersClientData = [
      { v: client.name, t: "s", s: { alignment: { horizontal: "center", vertical: "center", wrapText: true }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0086D7" } } } },
      { v: infosClient.idType || "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Endereço", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", bold: true, sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
    ];
    let clientData = [
      { v: " ", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: infosClient.idNumber || "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: " ", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: " ", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: `${clientAddress.uf || ""}, ${clientAddress.bairro || ""}, ${clientAddress.logradouro || ""}`, t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: " ", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
    ];
    let headersGeneralData = [
      { v: "Período", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Referencia", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "Valor", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Água (M³)", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "Esgoto (M³)", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Economia", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Meta", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
    ];
    let generalData = [
      { v: "Período", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "6b6b6b" } }, fill: { fgColor: { rgb: "FFFFFF" } } } },
      typedCell(client.reference, textStyle("F7F7F7"), "currency"),
      typedCell(client.account_value, textStyle("FFFFFF"), "currency"),
      typedCell(client.water_liters, textStyle("F7F7F7"), "decimal"),
      typedCell(client.sewer_liters, textStyle("FFFFFF"), "decimal"),
      typedCell(client.economy_monetary, textStyle("F7F7F7"), "currency"),
      typedCell(client.economy_percentage, textStyle("FFFFFF"), "percent"),
      typedCell(client.goal, textStyle("F7F7F7"), "percent"),
    ];
    let headersDetails = [
      { v: "Unidade", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Referencia", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "Valor", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Água (M³)", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "Esgoto (M³)", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Economia", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "056AAE" } } } },
      { v: "", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
      { v: "Meta", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 12, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "0C77BD" } } } },
    ];
    const datailName = [
      { v: "Detalhados", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 14, bold: true, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "095183" } } } },
    ];
    const generalDataName = [
      { v: "DADOS GERAIS", t: "s", s: { alignment: { horizontal: "center" }, font: { name: "Roboto", sz: 16, bold: true, color: { rgb: "ffffff" } }, fill: { fgColor: { rgb: "095183" } } } },
    ];
    let ws = XLSX.utils.aoa_to_sheet([
      headersClientData,
      clientData,
      whiteLine,
      generalDataName,
      headersGeneralData,
      generalData,
      whiteLine,
      datailName,
      headersDetails,
      ...dataLines
    ]);
    var wscols = [
      { wch: maxLengthNameUnit*1.3 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ];
    ws['!cols'] = wscols;

    XLSX.utils.book_append_sheet(wb, ws,client.name.substr(0, 25));
    wb.Sheets[client.name.substr(0, 25)]["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },
      { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } },
      { s: { r: 1, c: 1 }, e: { r: 1, c: 3 } },
      { s: { r: 0, c: 4 }, e: { r: 0, c: 7 } },
      { s: { r: 1, c: 4 }, e: { r: 1, c: 7 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: 7 } },
      { s: { r: 3, c: 0 }, e: { r: 3, c: 7 } },
      { s: { r: 4, c: 5 }, e: { r: 4, c: 6 } },
      { s: { r: 6, c: 0 }, e: { r: 6, c: 7 } },
      { s: { r: 7, c: 0 }, e: { r: 7, c: 7 } },
      { s: { r: 8, c: 5 }, e: { r: 8, c: 6 } },
    ]

  })


  XLSX.writeFile(wb, `Relatorio-Economia.xlsx`);

}
